import { useContext } from "react";
import PermissionContext from "../permission/PermissionContext";

const usePermission = () => useContext(PermissionContext);

export default usePermission;